import { UtilityService } from '@eforall/common';
import { GridSetup } from '@eforall/dashboard';
import { EntrepreneurProspectDialogDataService } from '../../entrepreneur-prospect-dialog-data.service';
import { AlignedCommitment } from '../aligned-commitments.part';
import { getActions } from './get-actions';
import { getButtons } from './get-buttons';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, entrepreneurProspectDialogDataService: EntrepreneurProspectDialogDataService): GridSetup<AlignedCommitment> {

	return {
		rowName: { singular: 'Commitment', plural: 'Commitments' },
		getRowKey: row => '' + row.accProspectCommitmentId,
		stateKey: 'entrepreneur-prospect-dialog-aligned-commitments-grid',
		actions: getActions(),
		buttons: getButtons(entrepreneurProspectDialogDataService),
		columns: getColumns(util),
	}
}
